export function isCatalogVersionNewer(
  stored: string,
  catalog: string,
): boolean {
  const parse = (v: string) => v.split('.').map((n) => parseInt(n, 10) || 0);
  const [sA, sB, sC] = parse(stored);
  const [cA, cB, cC] = parse(catalog);
  if (cA !== sA) return cA > sA;
  if (cB !== sB) return cB > sB;
  return cC > sC;
}
